import axiosInstance from "../helpers/axiosInstance";

export const getreportcustomerApi = async (pageNo, filterData = {}) => {
    let url = `staff/reports/customers?page=${pageNo}`;

    if (Object.keys(filterData).length > 0) {
        const params = new URLSearchParams({
            firstName: filterData.firstName ?? "",
            userId: filterData.userId ?? "",
            fromDate: filterData.fromDate ?? "",
            toDate: filterData.toDate ?? "",
            page: pageNo
        });

        url = `staff/reports/customers?${params.toString()}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
};
